import React from 'react';
import {BrowserRouter, Switch, Route } from 'react-router-dom';
import './App.css';
import Header from './components/header/header';
import Login from './components/login/login';
import Home from './components/home/home';
import NoMatch from './components/404page/404page';

class App extends React.Component {

  state={
    isLog:false
  }

  handleLogin = (isLog) => this.setState({isLog})

  render(){
    const {isLog} = this.state;
    return (
      <div className="App">
        
          <Header isLogin={this.handleLogin} isLog={this.state.isLog} />
          <BrowserRouter>
            <Switch>
              <Route 
                exact path="/" 
                render={
                  ()=>!isLog ?<Login isLogin={this.handleLogin}/>
                  : <Home /> } />
                  <Route path='*' component={NoMatch} />
            </Switch>
          </BrowserRouter>     
        
      </div>
    )
  }
}

export default App;
